// src/services/applePayService.ts

import axios from 'axios';

export const processPayment = async (payment, slug: string, locale: string, rockmanId: string): Promise<any> => {
  const response = await axios.post(
    '/api/v1/frontend/gp-payment',
    {
      rockmanId,
      slug,
      bankId: 4, // Celeris Pay
      locale,
      token: payment
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': '{{ csrf_token() }}'
      }
    }
  );
  return response.data;
};
